[
  {
    "medicationId": "med-follitropin-alfa",
    "canonicalName": "Follitropin alfa",
    "usBrands": ["Gonal-F"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed brand; the label includes prescribing information and patient counseling material.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Gonal-F (follitropin alfa) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=ae85b9c3-e7eb-4981-a5d9-346050e8f189",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Gonal-F (follitropin alfa)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-follitropin-beta",
    "canonicalName": "Follitropin beta",
    "usBrands": ["Follistim"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed brand; use the product-specific patient instructions for administration.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Follistim AQ (follitropin beta) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=48489027-e52b-4b10-ae74-4ba03839150c",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Follistim AQ (follitropin beta)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-follitropin-delta",
    "canonicalName": "Follitropin delta",
    "usBrands": ["Rekovelle"],
    "status": "market-data-conflict",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "Do not show a U.S. factsheet resource until the legacy U.S. brand entry is reconciled with current market authorization data.",
    "verifiedOn": "2026-07-17",
    "followUp": "Rekovelle has no current DailyMed U.S. label in the audit lookup; clinical/content review must confirm whether the legacy U.S. entry is stale before any link is added."
  },
  {
    "medicationId": "med-menotropins",
    "canonicalName": "Menotropins",
    "usBrands": ["Menopur"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed fertility product, including mixing and injection instructions.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Menopur (menotropins) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=22c8db95-c3db-1770-8086-31356fbabe35",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Menopur (menotropins)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-urofollitropin",
    "canonicalName": "Urofollitropin",
    "usBrands": ["Bravelle"],
    "status": "market-data-conflict",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "Do not show a U.S. factsheet resource until the legacy Bravelle entry is reconciled with current U.S. availability.",
    "verifiedOn": "2026-07-17",
    "followUp": "Bravelle has no current DailyMed U.S. label in the audit lookup; confirm discontinuation/market status and remove or correct the legacy U.S. brand entry."
  },
  {
    "medicationId": "med-cetrorelix",
    "canonicalName": "Cetrorelix",
    "usBrands": ["Cetrotide", "Cetrorelix Acetate for Injection"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the named U.S. fertility brand; the patient leaflet is part of the label.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Cetrotide (cetrorelix acetate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=aca7768e-28a7-4027-b1d8-e66247665f79",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Cetrotide (cetrorelix acetate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-ganirelix",
    "canonicalName": "Ganirelix",
    "usBrands": ["Fyremadel", "Ganirelix Acetate"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed fertility brand; use the product label for administration details.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Fyremadel (ganirelix acetate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=5f0908b5-3551-47fd-95f7-3669b0dff7f1",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Fyremadel (ganirelix acetate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-leuprolide",
    "canonicalName": "Leuprolide acetate",
    "usBrands": ["Lupron", "Lupron Depot"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. Lupron product; formulation and indication must be checked against the prescription.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Lupron (leuprolide acetate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=319f0af7-6cc7-4a91-a28a-9ceea37d0ca8",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Lupron (leuprolide acetate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-triptorelin",
    "canonicalName": "Triptorelin",
    "usBrands": ["Trelstar"],
    "status": "verified",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "DailyMed SPL for the legacy U.S. Trelstar entry; reconcile the newer availability list before release.",
    "verifiedOn": "2026-07-17",
    "followUp": "Add Trelstar to the current availability model or remove the legacy U.S. entry after clinical/content review.",
    "resource": {
      "label": "Trelstar (triptorelin pamoate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=b1b84d62-a369-a4b7-5c41-dd1f553a18f3",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Trelstar (triptorelin pamoate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-buserelin",
    "canonicalName": "Buserelin",
    "usBrands": ["Suprefact"],
    "status": "market-data-conflict",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "Do not show a U.S. factsheet resource until the legacy Suprefact entry is reconciled with current U.S. availability.",
    "verifiedOn": "2026-07-17",
    "followUp": "Suprefact has no current DailyMed U.S. label in the audit lookup; confirm whether this is a stale legacy entry."
  },
  {
    "medicationId": "med-goserelin",
    "canonicalName": "Goserelin",
    "usBrands": ["Zoladex"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed implant product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Zoladex (goserelin) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=294b168b-6e5f-4db9-bf70-d599271458b3",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Zoladex (goserelin)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-nafarelin",
    "canonicalName": "Nafarelin",
    "usBrands": ["Synarel"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed nasal spray.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Synarel (nafarelin acetate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=d0aa57cb-d2f4-46d7-af43-7c8b06aa81a6",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Synarel (nafarelin acetate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-hcg-recombinant",
    "canonicalName": "Choriogonadotropin alfa",
    "usBrands": ["Ovidrel"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed recombinant hCG product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Ovidrel (choriogonadotropin alfa) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=a683e58a-63ea-44b8-a326-1a99a537bcf2",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Ovidrel (choriogonadotropin alfa)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-hcg-urinary",
    "canonicalName": "Urinary-derived human chorionic gonadotropin",
    "usBrands": ["Pregnyl", "Novarel"],
    "status": "needs-clinical-review",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "Do not reuse a similarly named DailyMed record until the active ingredient and urinary-derived formulation are confirmed against the current U.S. product label.",
    "verifiedOn": "2026-07-17",
    "followUp": "The initial DailyMed lookup returned a Pregnyl record whose title identifies choriogonadotropin alfa; this is not an exact enough match for the urinary-derived content block."
  },
  {
    "medicationId": "med-dual-trigger",
    "canonicalName": "Leuprolide + low-dose hCG",
    "usBrands": ["Lupron + Pregnyl", "Lupron + Ovidrel"],
    "status": "needs-clinical-review",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "A composite protocol must link to the exact component products, not to a made-up composite medication label.",
    "verifiedOn": "2026-07-17",
    "followUp": "Model component resources through the linked Lupron, Ovidrel, and/or Pregnyl blocks after clinical review."
  },
  {
    "medicationId": "med-progesterone-suppositories",
    "canonicalName": "Micronized progesterone vaginal insert",
    "usBrands": ["Endometrin"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed vaginal insert.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Endometrin (progesterone) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=2ba50fa9-b349-40cb-9a4b-1af8faa4ec09",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Endometrin (progesterone vaginal insert)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-progesterone-in-oil",
    "canonicalName": "Progesterone in oil",
    "usBrands": ["Progesterone in Oil (compounded)", "PIO"],
    "status": "missing",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "No single U.S. official product resource is safe to attach to a compounded preparation; the pharmacy-specific label must remain authoritative.",
    "verifiedOn": "2026-07-17",
    "followUp": "Add a patient-facing administration resource only after clinical review confirms a non-product-specific source and compounding disclaimer."
  },
  {
    "medicationId": "med-progesterone-gel",
    "canonicalName": "Progesterone vaginal gel",
    "usBrands": ["Crinone", "Prochieve"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed vaginal gel.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Crinone (progesterone) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=75e97aa1-daa4-45f9-b2e2-1a371302914e",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Crinone (progesterone vaginal gel)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-progesterone-oral",
    "canonicalName": "Micronized progesterone oral capsule",
    "usBrands": ["Prometrium"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed oral capsule.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Prometrium (progesterone) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=1cf237ff-c4f8-4faa-a7aa-77599c856889",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Prometrium (micronized progesterone oral capsule)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-estradiol-oral",
    "canonicalName": "Estradiol oral tablet",
    "usBrands": ["Estrace"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for an exact U.S. estradiol tablet formulation; the branded Estrace search result also contains non-oral formulations, so the generic tablet match is intentional.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Estradiol tablet U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=5c9a2e0f-704b-4d16-8ea3-d94f7f36ce6b",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Estradiol oral tablet",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-estradiol-patches",
    "canonicalName": "Estradiol transdermal patch",
    "usBrands": ["Climara", "Vivelle-Dot"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Climara patch; other patch brands remain separate product matches.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Climara (estradiol patch) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=1e9702c4-f2d7-4ea8-b6e8-7dca31671864",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Climara (estradiol transdermal patch)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-estradiol-valerate",
    "canonicalName": "Estradiol valerate injection",
    "usBrands": ["Delestrogen"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed injection.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Delestrogen (estradiol valerate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=e8f94df9-0692-4462-a7f0-fe019a0a3f07",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Delestrogen (estradiol valerate injection)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-clomiphene",
    "canonicalName": "Clomiphene citrate",
    "usBrands": ["Clomid", "Serophene"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed fertility brand.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Clomid (clomiphene citrate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=2ca373c1-4dba-4126-8616-5c533d606fe5",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Clomid (clomiphene citrate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-letrozole",
    "canonicalName": "Letrozole",
    "usBrands": ["Femara"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Femara product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Femara (letrozole) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=82b77d74-085f-45ac-a7dd-1f5c038bf406",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Femara (letrozole)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-anastrozole",
    "canonicalName": "Anastrozole",
    "usBrands": ["Arimidex", "Anastrozole (generic)"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Arimidex product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Arimidex (anastrozole) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=acbfaaa9-503c-4691-9828-76a7146ed6de",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Arimidex (anastrozole)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-enoxaparin",
    "canonicalName": "Enoxaparin sodium",
    "usBrands": ["Lovenox", "Crusia"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. Lovenox product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Lovenox (enoxaparin sodium) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=5017a927-2a24-4f27-89f9-27c805bf7d59",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Lovenox (enoxaparin sodium)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-dalteparin",
    "canonicalName": "Dalteparin sodium",
    "usBrands": ["Fragmin"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the U.S. marketed product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Fragmin (dalteparin sodium) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=23527b8b-9b28-4e6d-9751-33b143975ac7",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Fragmin (dalteparin sodium)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-low-dose-aspirin",
    "canonicalName": "Acetylsalicylic acid low dose",
    "usBrands": ["Baby Aspirin (81 mg)"],
    "status": "missing",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "Do not attach a prescription-product label to an OTC dose; use a reviewed patient-education source that explicitly covers low-dose aspirin.",
    "verifiedOn": "2026-07-17",
    "followUp": "Confirm the intended audience and add an FDA or patient-facing resource specific to low-dose aspirin after clinical review."
  },
  {
    "medicationId": "med-doxycycline",
    "canonicalName": "Doxycycline",
    "usBrands": ["Doxycycline", "Vibramycin"],
    "status": "verified",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "DailyMed SPL for the generic U.S. doxycycline product; formulation-specific prescribing instructions remain authoritative.",
    "verifiedOn": "2026-07-17",
    "followUp": "Reconcile the legacy U.S. brand map with the newer availability shape.",
    "resource": {
      "label": "Doxycycline hyclate U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4dc319c1-b7ef-40e4-9e66-fb24cfdefea8",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Doxycycline hyclate",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-methylprednisolone",
    "canonicalName": "Methylprednisolone / prednisone",
    "usBrands": ["Medrol", "Prednisone", "Dexamethasone"],
    "status": "needs-clinical-review",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "Do not attach one label to this multi-molecule content block; each active ingredient and formulation needs its own reviewed resource.",
    "verifiedOn": "2026-07-17",
    "followUp": "Split the content identity or model component resources before adding U.S. links."
  },
  {
    "medicationId": "med-cabergoline",
    "canonicalName": "Cabergoline",
    "usBrands": ["Dostinex"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the exact active ingredient; the brand search did not return a current Dostinex record.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Cabergoline tablet U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=e497366b-a124-4d7f-bd45-a883c392d4bb",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Cabergoline tablet",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-metformin",
    "canonicalName": "Metformin hydrochloride",
    "usBrands": ["Glucophage", "Glucophage XR", "Metformin"],
    "status": "verified",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "DailyMed SPL for generic metformin hydrochloride; the exact immediate-release or extended-release formulation must be selected by the clinician.",
    "verifiedOn": "2026-07-17",
    "followUp": "Reconcile the legacy U.S. brand map with the newer availability shape.",
    "resource": {
      "label": "Metformin hydrochloride tablet U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=5aa1c86c-f2c8-49b1-8f81-47b11386c5d3",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Metformin hydrochloride tablet",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-diazepam",
    "canonicalName": "Diazepam",
    "usBrands": ["Valium", "Diazepam"],
    "status": "verified",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "DailyMed SPL for generic diazepam tablets; formulation and indication must be checked against the prescription.",
    "verifiedOn": "2026-07-17",
    "followUp": "Reconcile the legacy U.S. brand map with the newer availability shape.",
    "resource": {
      "label": "Diazepam tablet U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=20e08b97-bb89-4129-a228-8ad9cf35a1d3",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Diazepam tablet",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-sildenafil",
    "canonicalName": "Sildenafil citrate",
    "usBrands": [
      "Compounded vaginal sildenafil",
      "Viagra (oral, repurposed off-label)"
    ],
    "status": "needs-clinical-review",
    "availabilityEvidence": "availability",
    "sourcePolicy": "Do not show a pulmonary-hypertension or oral Viagra label for compounded vaginal off-label use without an explicit reviewed audience and formulation match.",
    "verifiedOn": "2026-07-17",
    "followUp": "Add separate resources for the compounded and oral use cases only after clinical/content review."
  },
  {
    "medicationId": "med-growth-hormone",
    "canonicalName": "Somatropin",
    "usBrands": [
      "Omnitrope",
      "Genotropin",
      "Saizen",
      "Norditropin",
      "Humatrope",
      "Nutropin",
      "Zomacton"
    ],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for Omnitrope, the canonical U.S. brand in this factsheet; other somatropin brands remain distinct matches.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Omnitrope (somatropin) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=58d84ffa-4056-4e36-ad67-7bd4aef444a5",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Omnitrope (somatropin)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-dexamethasone",
    "canonicalName": "Dexamethasone",
    "usBrands": ["Decadron", "generic dexamethasone"],
    "status": "verified",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "DailyMed SPL for generic dexamethasone tablets.",
    "verifiedOn": "2026-07-17",
    "followUp": "Reconcile the legacy U.S. brand map with the newer availability shape.",
    "resource": {
      "label": "Dexamethasone tablet U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=f5c9b70b-b835-4f3b-9643-0aec50a0d3f2",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Dexamethasone tablet",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-levothyroxine",
    "canonicalName": "Levothyroxine",
    "usBrands": ["Synthroid", "Levoxyl", "Tirosint", "Unithroid"],
    "status": "verified",
    "availabilityEvidence": "legacy brandsByCountry only",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Synthroid product.",
    "verifiedOn": "2026-07-17",
    "followUp": "Reconcile the legacy U.S. brand map with the newer availability shape.",
    "resource": {
      "label": "Synthroid (levothyroxine sodium) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=1e11ad30-1041-4520-10b0-8f9d30d30fcc",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Synthroid (levothyroxine sodium)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-bromocriptine",
    "canonicalName": "Bromocriptine mesylate",
    "usBrands": ["Parlodel", "Cycloset"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for Parlodel; the factsheet's fertility use must not be inferred from the label indication.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Parlodel (bromocriptine mesylate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=fc2a08dd-4fb6-4ac4-9082-f99552fae25c",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Parlodel (bromocriptine mesylate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-tamoxifen",
    "canonicalName": "Tamoxifen citrate",
    "usBrands": ["Nolvadex", "Soltamox"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for tamoxifen citrate tablets; Soltamox liquid remains a separate formulation.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Tamoxifen citrate tablet U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=509f8ba3-214d-aec8-e063-6294a90af498",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Tamoxifen citrate tablet",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-intralipid",
    "canonicalName": "Intralipid 20% IV fat emulsion",
    "usBrands": ["Intralipid", "SMOFlipid", "Liposyn"],
    "status": "verified",
    "availabilityEvidence": "availability + brandsByCountry",
    "sourcePolicy": "DailyMed SPL for the exact Intralipid U.S. product; this does not establish fertility efficacy or indication.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Intralipid (I.V. fat emulsion) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=61e025f1-a38e-4af2-9e18-13ea12977cf5",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Intralipid 20% I.V. fat emulsion",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-medroxyprogesterone",
    "canonicalName": "Medroxyprogesterone acetate",
    "usBrands": ["Provera", "Medroxyprogesterone (generic)"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for the U.S. Provera tablet.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Provera (medroxyprogesterone acetate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=a586be28-96af-4fed-a13f-9b94fd4c7405",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Provera (medroxyprogesterone acetate tablet)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-combined-oral-contraceptive",
    "canonicalName": "Combined oral contraceptive",
    "usBrands": ["Yasmin", "Yaz", "Loestrin", "Ortho Tri-Cyclen", "Alesse"],
    "status": "needs-clinical-review",
    "availabilityEvidence": "availability",
    "sourcePolicy": "This block represents multiple active ingredients and products; a single U.S. resource would be misleading.",
    "verifiedOn": "2026-07-17",
    "followUp": "Split by formulation or resolve a selected brand before adding a market-specific official resource."
  },
  {
    "medicationId": "med-hydroxychloroquine",
    "canonicalName": "Hydroxychloroquine sulfate",
    "usBrands": ["Plaquenil", "Hydroxychloroquine (generic)"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Plaquenil product.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Plaquenil (hydroxychloroquine sulfate) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=34496b43-05a2-45fb-a769-52b12e099341",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Plaquenil (hydroxychloroquine sulfate)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-filgrastim",
    "canonicalName": "Filgrastim",
    "usBrands": ["Neupogen", "Zarzio / Zarxio", "Nivestim / Nivestym"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Neupogen product; biosimilars remain separate product matches.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Neupogen (filgrastim) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=97cc73cc-b5b7-458a-a933-77b00523e193",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Neupogen (filgrastim)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-ivig",
    "canonicalName": "Intravenous immunoglobulin",
    "usBrands": ["Privigen", "Octagam", "Gammagard Liquid"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for Privigen, the canonical U.S. product in this block; the selected brand/formulation must be confirmed clinically.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Privigen (human immunoglobulin G) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=7e5649da-75be-4a42-8eeb-4aeba562c401",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Privigen (human immunoglobulin G)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-semaglutide",
    "canonicalName": "Semaglutide",
    "usBrands": ["Ozempic", "Wegovy", "Rybelsus"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for Ozempic, with the existing manufacturer Wegovy resource retained as a separate U.S. product link.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Ozempic (semaglutide) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=adec4fd2-6858-4c99-91d4-531f5f2a2d79",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Ozempic (semaglutide)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-tirzepatide",
    "canonicalName": "Tirzepatide",
    "usBrands": ["Mounjaro", "Zepbound"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for Mounjaro, with the existing manufacturer Zepbound resource retained as a separate U.S. product link.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Mounjaro (tirzepatide) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=d2d7da5d-ad07-4228-955f-cf7e355c8cc0",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Mounjaro (tirzepatide)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-liraglutide",
    "canonicalName": "Liraglutide",
    "usBrands": ["Saxenda", "Victoza"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for Saxenda, with the existing manufacturer Saxenda resource retained as a separate U.S. product link.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Saxenda (liraglutide) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=3946d389-0926-4f77-a708-0acb8153b143",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Saxenda (liraglutide)",
      "verifiedOn": "2026-07-17"
    }
  },
  {
    "medicationId": "med-warfarin",
    "canonicalName": "Warfarin sodium",
    "usBrands": ["Coumadin", "Jantoven", "Warfarin"],
    "status": "verified",
    "availabilityEvidence": "availability",
    "sourcePolicy": "DailyMed SPL for the exact U.S. Jantoven product; do not infer a dose or interaction plan from a generic resource alone.",
    "verifiedOn": "2026-07-17",
    "resource": {
      "label": "Jantoven (warfarin sodium) U.S. prescribing information",
      "url": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=19a69a72-ac5d-45d5-a94d-a5aaecbe4730",
      "type": "info",
      "market": "US",
      "authority": "DailyMed",
      "audience": "regulatory",
      "medicationMatch": "Jantoven (warfarin sodium)",
      "verifiedOn": "2026-07-17"
    }
  }
]
